import { COUNTRY } from '@/global'
import { t } from '@/plugins/i18n'
import flag_zh from '@/assets/image/logos/flag-icon-zh.svg'
import flag_ko from '@/assets/image/logos/flag-icon-ko.svg'
import { useRoute, useRouter } from 'vue-router'
import { computed, reactive, ref, watch } from 'vue'
import { isMultiStore } from '@/store'
import { useStore } from 'vuex'

enum Currency{
  CNY='CNY',
  KRW='KRW',
}

export const countrys = reactive([
  { name: COUNTRY.CN, label: t('china'), currency: Currency.CNY, flagIcon: flag_zh, cart: (count:number) => t('中国商品购物车') + `(${count})` },
  { name: COUNTRY.KR, label: t('korea'), currency: Currency.KRW, flagIcon: flag_ko, cart: (count:number) => t('韩国商品购物车') + `(${count})` }
])

export const useNav = (options?:any) => {
  const router = useRouter()
  const route = useRoute()
  const setQuery = (query:any, replace?:boolean) => {
    router.push({
      name: route.name as string,
      query: {
        ...route.query,
        ...query
      }
    })
  }
  return { router, route, setQuery }
}

export const sourceCountryRef = ref<COUNTRY>(location.search.includes('sc=KR') ? COUNTRY.KR : COUNTRY.CN)

export const useSourceCountry = () => {
  const { route, setQuery } = useNav()
  const country = computed<COUNTRY>(() => {
    const val = countrys.find((v) => v.name === route.query.sc) ? route.query.sc as COUNTRY : COUNTRY.CN
    sourceCountryRef.value = val
    return val
  })
  const changeCountry = (c:COUNTRY) => c === country.value || setQuery({ sc: c })
  return [country, changeCountry] as const
}

export const watchSourceCountry = (fn:Parameters<typeof watch>[1]) => {
  return watch(sourceCountryRef, fn)
}

export const concatProducts = () => {

}

export const sourceCountryInfo = computed(() => countrys.find((v) => v.name === sourceCountryRef.value))

const currency = {
  [COUNTRY.CN]: {
    symbol: '￥',
    code: 'CNY',
    local: 'zh-CN',
    name: t('元')
  },
  CNY: {
    symbol: '￥',
    code: 'CNY',
    local: 'zh-CN',
    name: t('元')
  },
  [COUNTRY.KR]: {
    symbol: '₩',
    code: 'KRW',
    local: 'ko-KR',
    name: t('韩元')
  },
  KRW: {
    symbol: '₩',
    code: 'KRW',
    local: 'ko-KR',
    name: t('韩元')
  },
  [COUNTRY.JP]: {
    symbol: '￥',
    code: 'JPY',
    local: 'ja-JP',
    name: t('日元')
  },
  JPY: {
    symbol: '￥',
    code: 'JPY',
    local: 'ja-JP',
    name: t('日元')
  }
}

export const tCurrency = (str:string, sc?:COUNTRY) => {
  const local = currency[sc ?? sourceCountryRef.value]
  // 临时先这样吧，不用改老代码^_^
  if (str === '元') {
    return ' ' + local.name
  }
  if (str === 'CNY') {
    return ' ' + local.code
  }
  if (str === '￥') {
    return ' ' + local.symbol
  }
}
